import { Components, Theme } from "@mui/material";

export const MuiCard: Components<Theme>["MuiCard"] = {
  styleOverrides: {
    root: {
      borderRadius: "1rem",
      background: "#fff",
      boxShadow: "none",
      border: "1px solid #ECEEF9",
      paddingLeft: "2rem",
      paddingRight: "2rem",
      paddingBottom: "0rem",
    },
  },
};
